import React, { useState } from "react";
import ManagementSidebar from "components/common/ManagementSidebar";
import "../components/admin-panel/Transaction/transaction.scss";
import { FaCheckCircle } from "react-icons/fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InternalTransaction from "components/Transaction/InternalTransaction";
const Transactions = () => {
  const [style, setstyle] = useState([true, false, false]);
  const click = (TAB) => {
    setstyle(
      style.map((value, index) => {
        if (index == TAB) {
          return true;
        } else {
          return false;
        }
      })
    );
  };
  // const datain = [
  //   {
  //     id: 1,
  //     name1: "temp 1",
  //     name2: "temp 2",
  //     date: new DateObject({ calendar: persian, locale: persian_fa }),
  //   },
  //   {
  //     id: 2,
  //     name1: "temp 1",
  //     name2: "temp 2",
  //     date: new DateObject({ calendar: persian, locale: persian_fa }),
  //   },
  //   {
  //     id: 3,
  //     name1: "temp 1",
  //     name2: "temp 2",
  //     date: new DateObject({ calendar: persian, locale: persian_fa }),
  //   },
  //   {
  //     id: 4,
  //     name1: "temp 1",
  //     name2: "temp 2",
  //     date: new DateObject({ calendar: persian, locale: persian_fa }),
  //   },
  // ];

  const dataout = [
    {
      id: 1,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "5041444468551199",
      originSheba: "",
      destinationCard: "5087874513259994",
      destinationSheba: "",
      trackingCode: "54678922",
    },
    {
      id: 2,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "5041444468551199",
      originSheba: "",
      destinationCard: "5087874513259994",
      destinationSheba: "",
      trackingCode: "54678922",
    },
    {
      id: 3,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "5041444468551199",
      originSheba: "",
      destinationCard: "5087874513259994",
      destinationSheba: "",
      trackingCode: "54678922",
    },
    {
      id: 4,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "5041444468551199",
      originSheba: "",
      destinationCard: "5087874513259994",
      destinationSheba: "",
      trackingCode: "54678922",
    },
    {
      id: 5,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "",
      originSheba: "5041321654842346254789",
      destinationCard: "",
      destinationSheba: "504144446855119912354789",
      trackingCode: "54678922",
    },
    {
      id: 6,
      timesubmit: new DateObject({ calendar: persian, locale: persian_fa }),
      name: "مشتاقی",
      mobile: "09123456789",
      timepay: new DateObject({ calendar: persian, locale: persian_fa }),
      amount: 12000000,
      originCard: "",
      originSheba: "5041321654842346254789",
      destinationCard: "",
      destinationSheba: "504144446855119912354789",
      trackingCode: "54678922",
    },
  ];
  return (
    <div className="d-flex">
      {/* <ManagementSidebar></ManagementSidebar> */}
      <div
        className="bg-white m-0 rounded-3 Transactions d-flex flex-column mt-5"
        // style={{ border: "1px solid gray" }}
        style={{ width: "100%" }}
      >
        <ul
          className="nav nav-pills m-3 w-75 mx-auto py-3 "
          id="pills-tab"
          role="tablist"
          style={{ borderBottom: "2px solid #303481" }}
        >
          <li className="nav-item mx-3 my-2" role="presentation">
            <a
              className="nav-link active btn border border-dark "
              onClick={() => click(0)}
              data-style={style[0]}
              id="buttonTAb1"
              data-bs-toggle="pill"
              data-bs-target="#Tab1"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
            >
              تراکنش های داخلی
            </a>
          </li>
          <li className="nav-item my-2" role="presentation">
            <a
              className="nav-link btn border border-dark me-2"
              onClick={() => click(1)}
              data-style={style[1]}
              id="buttonTAb2"
              data-bs-toggle="pill"
              data-bs-target="#Tab2"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
            >
              تراکنش های خارجی
            </a>
          </li>
        </ul>

        <div className="tab-content mx-auto" id="pills-tabContent">
          {/* تراکنش داخلی */}
          <InternalTransaction></InternalTransaction>
          ....
          {/* تراکنش خارجی */}
          <div
            class="tab-pane fade div-Shadow "
            id="Tab2"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div class="d-flex-reverse d-sm-flex align-items-start">
              <div
                class="nav flex-column nav-pills me-3 col-md-3 col-xl-2"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  class="nav-link active"
                  id="v-pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-home"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                >
                  نوع
                </button>
                <button
                  class="nav-link"
                  id="v-pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="false"
                >
                  اسم کاربر
                </button>
                <button
                  class="nav-link"
                  id="v-pills-messages-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-messages"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-messages"
                  aria-selected="false"
                >
                  زمان
                </button>
                <button
                  class="nav-link"
                  id="v-pills-settings-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-settings"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected="false"
                >
                  مبلغ
                </button>
              </div>
              <div
                class="tab-content col-md-9 col-xl-10"
                id="v-pills-tabContent"
              >
                <div
                  class="tab-pane fade show active"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  {dataout.map((value, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex flex-row px-3 my-3 mx-12 text-center text-md-start"
                        style={{
                          border: "2px solid #A7A9D6",
                          borderRadius: "10px",
                          // width: "48%",
                        }}
                      >
                        <FaCheckCircle
                          className="fs-3 me-2"
                          style={{ color: "#303481", marginTop: "13px" }}
                        />
                        <div className="d-flex flex-column justify-content-around w-100">
                          <div className="d-flex flex-column justify-content-between flex-wrap ">
                            <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                              <div>
                                <div className="d-xl-flex justify-content-between">
                                  <div>
                                    زمان ثبت: {value.timesubmit.format()}
                                  </div>
                                  <div>
                                    زمان پرداخت: {value.timepay.format()}
                                  </div>
                                </div>
                                <div>نام کاربر: {value.name}</div>
                                <div>شماره موبایل: {value.mobile}</div>
                                <div>مبلغ: {value.amount}</div>
                                <div className="d-xl-flex justify-content-between">
                                  {value.originCard != "" ? (
                                    <div>از کارت: {value.originCard}</div>
                                  ) : (
                                    <div>از شبا: {value.originSheba}</div>
                                  )}
                                  {value.destinationCard != "" ? (
                                    <div>به کارت: {value.destinationCard}</div>
                                  ) : (
                                    <div>به شبا: {value.destinationSheba}</div>
                                  )}
                                </div>
                                <div>کد پیگیری: {value.trackingCode}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-messages"
                  role="tabpanel"
                  aria-labelledby="v-pills-messages-tab"
                >
                  ...
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                >
                  ...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
